:host {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}

.wrapper {
  flex-direction: column;
  height: 100%;
  background: var(--white-layout-301-level-0-elevation);
}

.page__header {
  padding: calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(2.5 * var(--spacer));
}

.header__actions {
  display: flex;
}

.phasr-monitored-rules-grid-content {
  flex-grow: 2;
  height: 100%;

  .phasr-monitored-rules-grid {
    height: 100%;
  }

  gz-grid-view {
    min-height: 100%;
    align-items: stretch;
  }
}
